/**
 * WordPress dependencies
 */
import { createBlock } from '@wordpress/blocks';
export function createListItem(listItemAttributes, listAttributes, children) {
  return createBlock('core/list-item', listItemAttributes, !(children !== null && children !== void 0 && children.length) ? [] : [createBlock('core/list', listAttributes, children)]);
}
//# sourceMappingURL=utils.js.map